var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg404({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "52px",
    height: "52px",
    viewBox: "0 0 52 52",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Medewerkers",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Assets",
    transform: "translate(-217.000000, -254.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: 404,
    transform: "translate(217.000000, 254.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "circular-clock"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#498FA7",
    cx: 26,
    cy: 26,
    r: 26
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 26,
    cy: 26,
    r: 23.3103203
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 26,
    cy: 26,
    r: 21.5172344
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(6.195313, 6.195313)",
    fill: "#114D61"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.8046875,4.56330469 C19.3095703,4.56330469 18.9080937,4.16182813 18.9080937,3.66671094 L18.9080937,0.977132812 C18.9080937,0.482015625 19.3095703,0.0805390625 19.8046875,0.0805390625 C20.2998047,0.0805390625 20.7012812,0.482015625 20.7012812,0.977132812 L20.7012812,3.6668125 C20.7012812,4.16182813 20.2998047,4.56330469 19.8046875,4.56330469 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8046875,39.5288359 C19.3095703,39.5288359 18.9080937,39.1273594 18.9080937,38.6322422 L18.9080937,35.9425625 C18.9080937,35.4474453 19.3095703,35.0459688 19.8046875,35.0459688 C20.2998047,35.0459688 20.7012812,35.4474453 20.7012812,35.9425625 L20.7012812,38.6322422 C20.7012812,39.1273594 20.2998047,39.5288359 19.8046875,39.5288359 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0460703,19.8046875 C35.0460703,19.3095703 35.4475469,18.9080937 35.9426641,18.9080937 L38.6323437,18.9080937 C39.1274609,18.9080937 39.5289375,19.3095703 39.5289375,19.8046875 C39.5289375,20.2998047 39.1274609,20.7012812 38.6323437,20.7012812 L35.9426641,20.7012812 C35.4475469,20.7012812 35.0460703,20.2998047 35.0460703,19.8046875 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0805390625,19.8046875 C0.0805390625,19.3095703 0.482015625,18.9080937 0.977132812,18.9080937 L3.6668125,18.9080937 C4.16192969,18.9080937 4.56340625,19.3095703 4.56340625,19.8046875 C4.56340625,20.2998047 4.16192969,20.7012812 3.6668125,20.7012812 L0.977132812,20.7012812 C0.482015625,20.7012812 0.0805390625,20.2998047 0.0805390625,19.8046875 Z",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(8.734375, 8.734375)",
    fill: "#498FA7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.3472188,27.1276484 C34.0996094,27.5564453 33.5512734,27.7033047 33.1225781,27.4557969 L32.3461328,27.0075 C31.9173359,26.7598906 31.7704766,26.2115547 32.0179844,25.7827578 C32.2655938,25.3539609 32.8139297,25.2071016 33.242625,25.4546094 L34.0190703,25.9029063 C34.4479688,26.1505156 34.5948281,26.6989531 34.3472188,27.1276484 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.51326562,8.74839063 C2.26565625,9.1771875 1.71732031,9.32404688 1.288625,9.07653906 L0.512179687,8.62824219 C0.0833828125,8.38063281 -0.0634765625,7.83229688 0.18403125,7.40360156 C0.431640625,6.97480469 0.979976562,6.82794531 1.40867187,7.07545313 L2.18511719,7.52375 C2.61391406,7.77125781 2.760875,8.31959375 2.51326562,8.74839063 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.18403125,27.1276484 C0.431640625,27.5564453 0.979976563,27.7033047 1.40867188,27.4557969 L2.18511719,27.0075 C2.61391406,26.7598906 2.76077344,26.2115547 2.51326563,25.7827578 C2.26565625,25.3539609 1.71732031,25.2071016 1.288625,25.4546094 L0.512179688,25.9029063 C0.08328125,26.1505156 -0.063578125,26.6989531 0.18403125,27.1276484 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0179844,8.74839063 C32.2655938,9.1771875 32.8139297,9.32404688 33.242625,9.07653906 L34.0190703,8.62824219 C34.4478672,8.38063281 34.5947266,7.83229688 34.3472188,7.40360156 C34.0996094,6.97480469 33.5512734,6.82794531 33.1225781,7.07545313 L32.3461328,7.52375 C31.9173359,7.77125781 31.770375,8.31959375 32.0179844,8.74839063 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.40360156,34.3472188 C6.97480469,34.0996094 6.82794531,33.5512734 7.07545313,33.1225781 L7.52375,32.3461328 C7.77135938,31.9173359 8.31969531,31.7704766 8.74839063,32.0179844 C9.1771875,32.2655938 9.32404688,32.8139297 9.07653906,33.242625 L8.62824219,34.0190703 C8.38073438,34.4479688 7.83229688,34.5948281 7.40360156,34.3472188 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7828594,2.51326562 C25.3540625,2.26565625 25.2072031,1.71732031 25.4547109,1.288625 L25.9030078,0.512179687 C26.1506172,0.0833828125 26.6989531,-0.0634765625 27.12775,0.18403125 C27.5565469,0.431640625 27.7034063,0.979976562 27.4558984,1.40867187 L27.0076016,2.18511719 C26.7599922,2.61391406 26.2116563,2.760875 25.7828594,2.51326562 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.40360156,0.18403125 C6.97480469,0.431640625 6.82794531,0.979976563 7.07545313,1.40867188 L7.52375,2.18511719 C7.77135938,2.61391406 8.31969531,2.76077344 8.74839063,2.51326563 C9.1771875,2.26565625 9.32404688,1.71732031 9.07653906,1.288625 L8.62824219,0.512179688 C8.38073438,0.08328125 7.83229688,-0.063578125 7.40360156,0.18403125 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7828594,32.0179844 C25.3540625,32.2655938 25.2072031,32.8139297 25.4547109,33.242625 L25.9030078,34.0190703 C26.1506172,34.4478672 26.6989531,34.5947266 27.12775,34.3472188 C27.5565469,34.0996094 27.7034063,33.5512734 27.4558984,33.1225781 L27.0076016,32.3461328 C26.7599922,31.9173359 26.2116563,31.770375 25.7828594,32.0179844 Z",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#0B2730",
    transform: "translate(28.344387, 20.476971) rotate(-67.000000) translate(-28.344387, -20.476971) ",
    x: 21.3443868,
    y: 19.4769709,
    width: 14,
    height: 2,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    fill: "#0B2730",
    transform: "translate(30.373099, 28.424048) rotate(119.000000) translate(-30.373099, -28.424048) ",
    x: 29.3730985,
    y: 22.4240481,
    width: 2,
    height: 12,
    rx: 1
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.a3f9145b6da467207a1fe9b780ce0bea.svg";
export { ForwardRef as ReactComponent };